import React, { lazy } from "react";

import MainLayout from "../layout/MainLayout";

const HomePage = lazy(() => import("../views/Home"));

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <HomePage />,
    },
  ],
};

export default MainRoutes;
